import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AccessControlController } from '@shared/src/controllers/accesscontrol/accesscontrol.controller';
import { ForkliftDto } from '@shared/src/dtos/accesscontrol/forklift/ForkliftDto';
import { AccessControlGatePlateDto } from '@shared/src/dtos/accesscontrol/gate/plate/AccessControlGatePlateDto';

@Component({
    selector: 'shared-forklift-right',
    templateUrl: './shared.forklift.right.component.html',
    styleUrls: ['./shared.forklift.right.component.scss']
})
export class SharedForkliftRightComponent {

    @Input() public value: ForkliftDto | null = null;
    @Input() public open: boolean = false;
    @Input() public selectedRoute: AccessControlGatePlateDto | null = null;
    @Input() public actionsWidth: number = 200;
    @Output() public openChange = new EventEmitter<boolean>();

    constructor(
        private accessControlController: AccessControlController) { }

    toggle() {
        this.openChange.emit(!this.open);
    }
    public pretty(value: any): string {
        return JSON.stringify(value);
    }

    onRouteRefresh($event: boolean) {
        if (this.selectedRoute != null) {
            this.accessControlController.refreshRoute(this.selectedRoute).subscribe(d => {
                this.selectedRoute = d;
            });
        }
    }

}
